import Vue from 'vue'
import Vuex from 'vuex'
import keycloak from "@/store/keycloak";
import cNotifications from "@/store/cNotifications"
import checkFilled from "@/store/checkFilled";
import spr from "@/store/spr";
import VuexPersistence from "vuex-persist";
import appeals from "@/store/appeals";

Vue.use(Vuex);


const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: (state) => ({
    keycloak: state.keycloak,
  }),
  // filter: mutation => mutation.type === 'TABLE_HEADER_ASYNC'
});
// import * as Modules from './modules';
export default new Vuex.Store({
  // modules: Modules
  modules: {
    notifications: cNotifications,
    keycloak: keycloak,
    spr: spr,
    appeals,
    checkFilled: checkFilled
  },
  plugins: [vuexLocal.plugin]
});